export class SetTabById {
   public static readonly type = '[Tab Brick Behavior] Set Tab By Id';

   constructor(public brickInstanceId: string, public tabId: string) {}
}

export class SetTabByIndex {
   public static readonly type = '[Tab Brick Behavior] Set Tab By Index';

   constructor(public brickInstanceId: string, public index: number) {}
}

export class SetTabIndex {
   public static readonly type = '[Tab Brick Behavior] Set Tab Index';

   constructor(public brickInstanceId: string, public index: number) {}
}
